<template>
    <section class="hero confirm-mail is-fullheight">
        <div class="hero-body">
            <div class="container">
                <!--suppress HtmlUnknownTarget -->
                <img
                    v-if="$saas.main"
                    alt="logo"
                    :src="require(`@/assets/${ $saas.logo }`)">
                <!--suppress HtmlUnknownTarget -->
                <img
                    alt="mail-image"
                    src="@/assets/MailConfirmation/failed.png">
                <h1 class="has-text-black is-title has-text-centered">
                    {{ $t(`common.mailConfirmation.failed.title`) }}
                </h1>
                <a
                    :href="link"
                    class="button is-success is-rounded is-fullwidth">
                    {{ $t(`common.mailConfirmation.failed.link`) }}
                </a>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: "MailConfirmationFailed",
    computed: {
      link () {
        return process.env.VUE_APP_LANDING_PAGE_URL;
      }
    }
  };
</script>


